function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { colors } from '../../../../theme';

var BaseDiagonalArrow = function BaseDiagonalArrow(props) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 12 11",
    fill: "none",
    transform: props.rotation ? "rotate(".concat(props.rotation, ")") : undefined,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.40237 1.03259H10.5563M10.5563 1.03259V8.18651M10.5563 1.03259L1 9.96741",
    stroke: props.color || colors.WHITE,
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
};

export var DiagonalArrow = function DiagonalArrow(props) {
  return /*#__PURE__*/React.createElement(BaseDiagonalArrow, props);
};
export var ArrowUpRight = DiagonalArrow;
export var ArrowUpLeft = function ArrowUpLeft(props) {
  return /*#__PURE__*/React.createElement(BaseDiagonalArrow, _extends({}, props, {
    rotation: 270
  }));
};
export var ArrowDownLeft = function ArrowDownLeft(props) {
  return /*#__PURE__*/React.createElement(BaseDiagonalArrow, _extends({}, props, {
    rotation: 180
  }));
};
export var ArrowDownRight = function ArrowDownRight(props) {
  return /*#__PURE__*/React.createElement(BaseDiagonalArrow, _extends({}, props, {
    rotation: 90
  }));
};